import { Dropdown, Radio } from 'ccs-ui-components';

import { useTranslation } from 'react-i18next';
import classes from '../create-schedule/CreateSchedule.module.scss';
import styles from '../job-scheduler/JobScheduler.module.scss';

type OptionType = {
  value: number | string;
  name: string;
};
interface MonthTxtProps {
  monthlyText: string;
}
interface MonthProps {
  startDay: number
  monthDaysHandler: (val: number) => void;
  listWeek: string | number;
  listWeekHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  listDays: string;
  listDaysHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  monthRadio: boolean
  monthRadioHandler: () => void;
}

export const MonthlyTxtComp = (props: MonthTxtProps) => {
  const { monthlyText } = props;

  return (
    <div className={classes['month-align']} data-testid="monthText">
      {monthlyText}
    </div>
  );
};

export const MonthlyComp = (props: MonthProps) => {
  const { startDay, monthDaysHandler, listWeek, listWeekHandler, listDays, listDaysHandler, monthRadio, monthRadioHandler } = props;
  const { t: translate } = useTranslation();

  /**
   * @method blurHandler
   * @description handles the blur when input is entered in days of month input
   * @param {React.SyntheticEvent<HTMLInputElement>} e
   */

  const daysList: OptionType[] = [
    { value: 'Monday', name: String(translate('month_component.txt_monday')) },
    { value: 'Tuesday', name: String(translate('month_component.txt_tueday')) },
    { value: 'Wednesday', name: String(translate('month_component.txt_wedday')) },
    { value: 'Thursday', name: String(translate('month_component.txt_thursday')) },
    { value: 'Friday', name: String(translate('month_component.txt_friday')) },
    { value: 'Saturday', name: String(translate('month_component.txt_satday')) },
    { value: 'Sunday', name: String(translate('month_component.txt_sunday')) },
  ];

  const constantText = {
    ON_DAY: translate('month_component.txt_on_day'),
    ON_THE: translate('month_component.txt_on_the')
  };

  const weekList: OptionType[] = [
    { name: translate('month_component.txt_first'), value: 1 },
    { name: translate('month_component.txt_second'), value: 2 },
    { name: translate('month_component.txt_third'), value: 3 },
    { name: translate('month_component.txt_fourth'), value: 4 },
  ];

  const blurHandler = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const value = parseInt(e.currentTarget.value, 10);
    if (value > 0 && value <= 31) {
      monthDaysHandler(value - 1);
    } else if (value <= 0 || e.currentTarget.value === '' || Number.isNaN(value)) {
      e.currentTarget.value = '1';
      monthDaysHandler(0);
    } else if (value > 31) {
      e.currentTarget.value = '31';
      monthDaysHandler(30);
    }
  };

  /**
   * @method keyUpHandler
   * @description executes the onblurHandler function on enter
   * @param {React.KeyboardEvent<HTMLInputElement>} e
   */
  const keyUpHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      blurHandler(e);
    }
  };

  /**
 * @method keydownHandler
 * @description prevents the miscellaneous numeric values to be entered
 * @param {React.KeyboardEvent<HTMLInputElement>} e
 */
  const keydownHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const notValid = ['e', 'E', '+', '-', '.'];
    if (notValid.includes(e.key)) e.preventDefault();
  };

  return (
    <div className={styles['month-container']} data-testid="monthComp">
      <div className={styles['first-radio-option']}>
        <Radio
          name="day-radio"
          checked={monthRadio}
          onChange={monthRadioHandler}
          className={styles.radio}
          data-testid="dayRadio"
        />
        <p>{constantText.ON_DAY}</p>
        <input
          type="number"
          className={styles['month-day-input']}
          onBlur={blurHandler}
          onKeyUp={keyUpHandler}
          onKeyDown={keydownHandler}
          defaultValue={startDay + 1}
          key={startDay + 1}
          disabled={!monthRadio}
          min={1}
          max={31}
          data-testid="daysOfMonth"
        />
      </div>
      <div className={styles['second-radio-option']}>
        <Radio
          name="weekday-radio"
          checked={!monthRadio}
          onChange={monthRadioHandler}
          className={styles.radio}
          data-testid="weekRadio"
        />
        <p>{constantText.ON_THE}</p>
        <Dropdown
          label=""
          data={weekList}
          className={styles['week-dropdown-control']}
          value={listWeek}
          onChange={listWeekHandler}
          disabled={monthRadio}
          data-testid="weekList"
        />
        <Dropdown
          label=""
          data={daysList}
          className={styles['month-dropdown-control']}
          value={listDays}
          onChange={listDaysHandler}
          disabled={monthRadio}
          data-testid="daysList"
          placeholder={translate('journey_builder_component.txt_select') ?? ''}
        />
      </div>
    </div>
  );
};
